/// <reference types="@capacitor/cli" />

declare module '@capacitor/cli' {
  export interface PluginsConfig {
    /**
     * These config values are available:
     */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    LiveUpdates?: {
      /**
       * The id of the app in Appflow
       *
       * @since 0.0.1
       */
      appId: string;
      /**
       * The channel of the app to update from
       *
       * @since 0.0.1
       */
      channel: string;
      /**
       * The method to update
       *
       * @since 0.0.1
       */
      autoUpdateMethod: 'none' | 'background';

      /**
       * The strategy to use for updating
       *
       * @since 0.1.1
       *
       * @default 'differential'
       *
       */
      strategy?: 'zip' | 'differential';

      /**
       * If the plugin should be enabled or not
       *
       * @since 0.1.1
       *
       * @default true
       */
      enabled?: boolean;

      /**
       * The maximum number of versions of the app to keep cached on device
       *
       * @since 0.0.1
       */
      maxVersions?: number;

      /**
       * The path to the public key to validate the signature of a Live Update
       *
       * @since 0.0.1
       */
      key?: string;

      /**
       * The token provided by Ionic/Outsystems to enable a custom base URL
       */
      urlToken?: string;
    };
  }
}

export type LiveUpdateConfig = Partial<LiveUpdate> & {
  autoUpdateMethod?: 'none' | 'background';
  strategy?: 'zip' | 'differential';
  enabled?: boolean;
  maxVersions?: number;
};

export interface LiveUpdate {
  appId: string;
  channel: string;
}

export interface Snapshot {
  id: string;
  buildId: string;
}

export interface SyncResult {
  liveUpdate: LiveUpdate;
  snapshot: Snapshot | null;
  source: 'download' | 'cache';
  activeApplicationPathChanged: boolean;
}

export interface LiveUpdateError {
  appId?: string;
  failStep: 'CHECK' | 'DOWNLOAD' | 'COPY' | 'UNPACK' | 'VERIFY' | 'UPDATE' | 'CANCEL';
  message: string;
}

export type LiveUpdateResult = SyncResult | LiveUpdateError;
